var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cma-field-row",class:{ 'cma-field-row--stacked': _vm.stacked }},[_c('span',{staticClass:"cma-field-row__label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('span',{staticClass:"cma-field-row__value",class:[
      { 'cma-field-row__value--highlighted': _vm.highlighted },
      _vm.status ? ("cma-field-row__value--" + _vm.status) : null ]},[_vm._v(_vm._s(_vm.displayValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }